import React, { useState, useEffect } from "react";

const ImageInput = ({ image, setImage, text, setImageBase64 }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    // Convert file to base64
    const convertToBase64 = async (file) => {
        if (!file || !(file instanceof Blob)) return;
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            if (setImageBase64) {
                setImageBase64(reader.result);
            }
        };
    };

    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setImage(file);
            convertToBase64(file);
        }
    };

    // Handle delete
    const handleDelete = () => {
        setImage(null);
        setSelectedFile(null);
        if (setImageBase64) {
            setImageBase64(null);
        }
    };

    return (
        <div className="profile-upload">
            {
                image ?
                    <div className="flex flex-col max-w-[180px] min-h-52 object-cover rounded relative">
                        <img 
                            src={typeof(image) === "string" ? image : URL.createObjectURL(image)} 
                            alt="" 
                            className='max-w-[180px] min-h-52 object-cover rounded-md' 
                        />
                        <div className='absolute w-full flex bg-[rgba(0,0,0,0.3)] justify-between bottom-0 rounded-b-md'>
                            <button 
                                type="button"
                                onClick={handleDelete} 
                                className='text-white py-1 px-3 w-full rounded-br-md'
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    :
                    <div className="border border-dashed border-border rounded-md min-w-[180px] min-h-52 flex justify-center items-center">
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            id="fileInput"
                            onChange={handleFileChange}
                        />
                        <label
                            htmlFor="fileInput"
                            className="cursor-pointer py-2 px-4 bg-navBtn text-sm font-semibold rounded hover:bg-primaryHover2"
                        >
                            Choose File
                        </label>
                    </div>
            }
            <p className="text-base mt-1 text-center text-slate-400 w-full">{text}</p>
        </div>
    );
}

export default ImageInput;